export default "__VITE_ASSET__x$A5FwtO__"